import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/common/Buttons/Button';
import ThreeppModal from 'components/common/Modal/Modal';
import CheckBox from 'components/common/Checkbox/Checkbox';

import './UserAgreement.scss';

export const UserAgreement = props => {
  const { toggle, isOpen, updateUser } = props;
  const { t } = useTranslation();

  const [enableLogin, setEnableLogin] = useState(false);

  const onOpened = useCallback(() => {
    setEnableLogin(false);
  }, []);

  const handleLogin = useCallback(() => {
    updateUser();
  }, [updateUser]);

  const handleAcceptLicense = useCallback(() => {
    setEnableLogin(!enableLogin);
  }, [enableLogin]);

  return (
    <ThreeppModal onOpened={onOpened} isOpen={isOpen} toggle={toggle} classes="user-agreement-modal" header={t('userAgreement.header')} size="lg">
      <div className="user-agreement-content">
        <div className="user-agreement-content-header">{t('userAgreement.content.header')}</div>
        <div className="para">
          <span className="para-header">{t('userAgreement.content.para1.header')}</span>
          {t('userAgreement.content.para1.line0')}
          {t('userAgreement.content.para1.line1')}
          {t('userAgreement.content.para1.line2')}
          {t('userAgreement.content.para1.line3')}
          {t('userAgreement.content.para1.line4')}
          {t('userAgreement.content.para1.line5')}
          {t('userAgreement.content.para1.line6')}
          {t('userAgreement.content.para1.line7')}
          {t('userAgreement.content.para1.line8')}
          {t('userAgreement.content.para1.line9')}
          {t('userAgreement.content.para1.line10')}
          {t('userAgreement.content.para1.line11')}
          {t('userAgreement.content.para1.line12')}
        </div>

        <div className="para">
          <span className="para-header">{t('userAgreement.content.para2.header')}</span>
          {t('userAgreement.content.para2.line0')}
          {t('userAgreement.content.para2.line1')}
          {t('userAgreement.content.para2.line2')}
          {t('userAgreement.content.para2.line3')}
          {t('userAgreement.content.para2.line4')}
        </div>
      </div>

      <CheckBox label={t('userAgreement.agreement')} onChange={handleAcceptLicense} />

      <div className="action-row">
        <Button className="btn-login" buttonStyle="primary" disabled={!enableLogin} onClick={handleLogin}>
          {t('userAgreement.login')}
        </Button>
      </div>
    </ThreeppModal>
  );
};

export default UserAgreement;
